module.exports = __webpack_public_path__ + "img/yuyuko saigyouji_sc2.a729af6e.png";